import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminInverterAlarm(props) {
    const formalarmRef = useRef(null)

    const [viewmode, setViewMode] = useState('Alarm Word/Bit')
    const [datalist, setDatalist] = useState([]);
    const [datalist_order, setDatalist_order] = useState([]);
    const [dataitem, setDataitem] = useState({
        id: 0,
        alarm_enable: '',
        alarm_level: '',
        alarm_message: '',
        alarm_group: '',
        alarm_bit: 0,
        output_shutdown_dc: '',
        output_shutdown_ac: '',
        output_pilot_lamp: '',
        output_buzzer: '',
        notify_line: '',
        notify_email: '',
        ack_req: '',
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_item, setModal_item] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        api_get_alarm_list()
        return () => {
            setDatalist([]);
            setDataitem({})
        }
    }, []);

    useEffect(() => {
        if (viewmode === "Alarm Word/Bit") {
            setDatalist_order(datalist.sort((a, b) => calculateOrder(a, b)))
        } else {
            setDatalist_order(datalist.sort((a, b) => a.id - b.id))
        }
    }, [datalist, viewmode]);

    const calculateOrder = (a, b) => {
        const num_word_previous = Number(a.alarm_group.replace("Alarm", ""))
        const num_word_new = Number(b.alarm_group.replace("Alarm", ""))
        const num_previous_seq = (num_word_previous * 16) + a.alarm_bit
        const num_new_seq = (num_word_new * 16) + b.alarm_bit
        return num_previous_seq - num_new_seq;
    };

    async function api_get_alarm_list() {
        setmodal_load({ enable: true, message: "Loading inverter alarm list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/inverteralarm/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.alarm !== null && response.data.alarm !== undefined) {
                        setDatalist(response.data.alarm)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_save_data() {
        var formelement = formalarmRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('id', dataitem.id)
            formData.append('alarm_enable', dataitem.alarm_enable)
            formData.append('alarm_level', dataitem.alarm_level)
            formData.append('alarm_message', dataitem.alarm_message)
            formData.append('alarm_group', dataitem.alarm_group)
            formData.append('alarm_bit', dataitem.alarm_bit)
            formData.append('output_shutdown_dc', dataitem.output_shutdown_dc)
            formData.append('output_shutdown_ac', dataitem.output_shutdown_ac)
            formData.append('output_pilot_lamp', dataitem.output_pilot_lamp)
            formData.append('output_buzzer', dataitem.output_buzzer)
            formData.append('notify_line', dataitem.notify_line)
            formData.append('notify_email', dataitem.notify_email)
            formData.append('ack_req', dataitem.ack_req)

            setmodal_load({ enable: true, message: "Saving inverter alarm." })
            await sleep(500)

            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/inverteralarm/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    setDataitem({
                        id: 0,
                        alarm_enable: '',
                        alarm_level: '',
                        alarm_message: '',
                        alarm_group: '',
                        alarm_bit: 0,
                        output_shutdown_dc: '',
                        output_shutdown_ac: '',
                        output_pilot_lamp: '',
                        output_buzzer: '',
                        notify_line: '',
                        notify_email: '',
                        ack_req: '',
                    })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your inverter alarm has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.alarm !== null && response.data.alarm !== undefined) {
                        setDatalist(response.data.alarm)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    setDataitem({
                        id: 0,
                        alarm_enable: '',
                        alarm_level: '',
                        alarm_message: '',
                        alarm_group: '',
                        alarm_bit: 0,
                        output_shutdown_dc: '',
                        output_shutdown_ac: '',
                        output_pilot_lamp: '',
                        output_buzzer: '',
                        notify_line: '',
                        notify_email: '',
                        ack_req: '',
                    })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_update_version() {
        setmodal_load({ enable: true, message: "Updating inverter alarm....." })
        await sleep(500)

        const formData = new FormData()
        formData.append('topic', "refinverteralarm")
        formData.append('password', "Automation01#")
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/inverteralarm/update", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "System has been send update signal to API.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-bell"></i> Inverter Alarm</h4>
                                    <p className="mb-3">Manage all inverter alarm system</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_get_alarm_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_update_version() }}><i className="fas fa-power-off"></i> Update to Local</button>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mt-3 mb-2">
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="event_class" className="form-label mb-0">Order by</label>
                            <select name="event_class" className="form-select" value={viewmode} onChange={(e) => {
                                setViewMode(e.target.value)
                            }} required>
                                <option value="Alarm Word/Bit">Alarm Word/Bit</option>
                                <option value="Alarm ID">Alarm ID</option>
                            </select>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Inverter Alarm List Table ({datalist_order.length} Alarms)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Alarm ID.</th>
                                        <th>Enable Status</th>
                                        <th>Alarm Level</th>
                                        <th>Alarm Group/Bit</th>
                                        <th>Alarm Message</th>
                                        <th>Signal Output</th>
                                        <th>Notify</th>
                                        <th>Acknowledge</th>
                                        <th>Model Support</th>
                                        <th>Edit Time</th>
                                        <th className="text-center" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist_order?.map((data, index) => (
                                            <tr key={"alarm-" + data.id}>
                                                <td><i className={"fas fa-bell "
                                                    + (data.alarm_enable ?
                                                        data.alarm_level === "Critical" || data.alarm_level === "Major" ?
                                                            "text-danger"
                                                            : data.alarm_level === "Minor" ?
                                                                "text-warning"
                                                                : data.alarm_level === "Warning" ?
                                                                    "text-yellow"
                                                                    : data.alarm_level === "Hints" ?
                                                                        "text-info"
                                                                        : "rows-icon"
                                                        :
                                                        "rows-icon"
                                                    )}></i> {data.id}</td>
                                                <td>{data.alarm_enable ? "Enable" : "Disable"}</td>
                                                <td>{data.alarm_level}</td>
                                                <td>{data.alarm_group} Bit {data.alarm_bit}</td>
                                                <td>{data.alarm_message}</td>
                                                <td>{data.shutdown_output}
                                                    <div className='d-flex gap-1'>
                                                        <span className={'badge ' + (data.output_shutdown_ac ? "bg-danger" : "bg-light text-dark")}>Main</span>
                                                        <span className={'badge ' + (data.output_shutdown_dc ? "bg-danger" : "bg-light text-dark")}>Rapid</span>
                                                        <span className={'badge ' + (data.output_pilot_lamp ? "bg-danger" : "bg-light text-dark")}>Lighting</span>
                                                        <span className={'badge ' + (data.output_buzzer ? "bg-danger" : "bg-light text-dark")}>Buzzer</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex gap-1'>
                                                        <span className={'badge ' + (data.notify_line ? "bg-success" : "bg-light text-dark")}>Line</span>
                                                        <span className={'badge ' + (data.notify_email ? "bg-success" : "bg-light text-dark")}>Email</span>
                                                    </div>
                                                </td>
                                                <td>{
                                                    data.ack_req ?
                                                        <span className="badge bg-warning">Required</span>
                                                        :
                                                        <span className="badge bg-light text-dark">None</span>
                                                }
                                                </td>
                                                <td>{data.model === "" ? "ALL" : data.model}</td>
                                                <td>{data.edittime}</td>
                                                <td>
                                                    <Link className="btn btn-icon btn-sm btn-success btn-hover btn-bordered" title="Edit" onClick={() => { setDataitem(data); setModal_item(true) }}><i className="fas fa-pen"></i></Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_item ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-xl modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-bell"></i> Edit Inverter Alarm</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_item(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formalarmRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-md-4">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="id">Alarm ID</label>
                                                                <input type="number" className="form-control" name="id" min={1} max={65535} step={1} value={dataitem.id} required readOnly />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="alarm_enable">Alarm Enable</label>
                                                            <select name="alarm_enable" className="form-select mb-3" value={dataitem.alarm_enable} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    alarm_enable: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6 col-md-4">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="alarm_level">Alarm Level</label>
                                                                <input type="text" className="form-control" name="alarm_level" value={dataitem.alarm_level} required readOnly />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-md-4">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="alarm_group">Alarm Group</label>
                                                                <input type="text" className="form-control" name="alarm_group" value={dataitem.alarm_group} required readOnly />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-md-4">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="alarm_bit">Alarm Bit</label>
                                                                <input type="number" className="form-control" name="alarm_bit" value={dataitem.alarm_bit} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="output_shutdown_ac">Output Shutdown Main (AC)</label>
                                                            <select name="output_shutdown_ac" className="form-select mb-3" value={dataitem.output_shutdown_ac} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    output_shutdown_ac: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="output_shutdown_dc">Output Shutdown Rapid (DC)</label>
                                                            <select name="output_shutdown_dc" className="form-select mb-3" value={dataitem.output_shutdown_dc} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    output_shutdown_dc: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="output_pilot_lamp">Output Lighting</label>
                                                            <select name="output_pilot_lamp" className="form-select mb-3" value={dataitem.output_pilot_lamp} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    output_pilot_lamp: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="output_buzzer">Output Buzzer</label>
                                                            <select name="output_buzzer" className="form-select mb-3" value={dataitem.output_buzzer} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    output_buzzer: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="notify_line">Notify to Line App.</label>
                                                            <select name="notify_line" className="form-select mb-3" value={dataitem.notify_line} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    notify_line: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="notify_email">Notify to Email</label>
                                                            <select name="notify_email" className="form-select mb-3" value={dataitem.notify_email} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    notify_email: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-6 col-md-4">
                                                            <label htmlFor="ack_req">Acknowledge Required</label>
                                                            <select name="ack_req" className="form-select mb-3" value={dataitem.ack_req} onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    ack_req: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="alarm_message">Alarm Message</label>
                                                                <input type="text" className="form-control" name="alarm_message" value={dataitem.alarm_message} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_item(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_save_data() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminInverterAlarm